import React from "react";
import { Helmet } from "react-helmet";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import { useAlert } from "../../components/Alert";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { IconButton, Typography, CircularProgress } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Copyright from "../../components/Copyright";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FarmAppLogo from "../../assets/logo/FarmAppLogo.png";
import BackButtonIcon from "../../assets/Icon/BackButtonIcon.png";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import axios from "axios";

const useStyles = makeStyles(() => ({
  root: {
    maxHeight: "100vh",
    margin: "auto",
    padding: "20px !important",
  },
  signUpTitle: {
    fontSize: "12px !important",
    textAlign: "center",
    marginTop: "20px !important",
    lineHeight: "40px !important",
  },
  subText: {
    fontSize: "12px !important",
    color: "#827F7F",
    fontWeight: "400 !important",
    marginLeft: "8px !important",
  },
}));
const LoginInitial = () => {
  const classes = useStyles();
  const [phoneEmail, setPhoneEmail] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const login = (event) => {
    setLoading(true);
    event.preventDefault();
    if (!phoneEmail) {
      showAlert("error", "Enter phone number or email");
      setLoading(false);
      return;
    }
    axios
      .get(
        `${SERVER_BASE_ADDRESS}/auth/get-user-roles/?phone_email=${phoneEmail}`
      )
      .then((result) => {
        if (result && result.data) {
          showAlert("success", "Roles fetched successfully");
        }

        navigate("/login-role-select", {
          state: {
            appuserData: result.data.data,
          },
        });
      })
      .catch((err) => {
        let error =
          err.response.data.message || "An error occurred. Please try again.";
        showAlert("error", error);
        setLoading(false);
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Helmet>
        <title>Login - Farmapp</title>
      </Helmet>
      <IconButton
        edge="start"
        sx={{ mx: "0.1rem", marginTop: "10px" }}
        aria-label="back"
        onClick={() => navigate(-1)}
      >
        <img src={BackButtonIcon} />
      </IconButton>
      <CssBaseline />
      <div
        style={{
          // marginTop: 100,
          display: "flex",
          padding: "20px",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          alt="farmapp"
          src={FarmAppLogo}
          style={{ width: "206", height: "188px" }}
        />
        <form
          style={{
            width: "100%",
            marginTop: 50,
          }}
          noValidate
          onSubmit={login}
        >
          <Typography variant="h6" align="center" mb={2}>
            {t("Login to FarmApp")}
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="Email Id"
            label={t("Email Id/Mobile")}
            name="phone_email"
            autoComplete="email"
            autoFocus
            onChange={(event) => setPhoneEmail(event.target.value)}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2, color: "white" }}
          >
            {loading ? (
              <CircularProgress size={28} style={{ color: "white" }} />
            ) : (
              t("Continue")
            )}{" "}
          </Button>
        </form>

        <div>
          <Typography className={classes.signUpTitle}>
            {t("Don't have an account? ")}
            <Link to="/signup" style={{ color: "#1F5674" }}>
              {t("Sign Up")}
            </Link>
          </Typography>
        </div>
      </div>

      <Box mt={4}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default LoginInitial;
